import { ArrowDown, Calendar } from "lucide-react";
import Reveal from "@/components/site/Reveal";

export default function CalHero() {
  return (
    <section
      data-testid="cal-hero"
      className="relative pt-36 pb-20 md:pt-44 md:pb-28 overflow-hidden bg-[#FAF7F8]"
    >
      <div className="absolute inset-0 -z-10 pointer-events-none">
        <div className="absolute top-10 right-0 w-[36rem] h-[36rem] rounded-full bg-[#E6D6DF]/40 blur-[140px]" />
        <div className="absolute -bottom-24 left-0 w-[32rem] h-[32rem] rounded-full bg-[#2847B8]/8 blur-[120px]" />
      </div>

      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/70 backdrop-blur border border-[#DDD7E2] text-xs uppercase tracking-[0.22em] text-[#3A2E6E]">
            <Calendar className="w-3.5 h-3.5 text-[#C98FA3]" />
            Calendrier 2026
          </span>
        </Reveal>

        <Reveal delay={0.08}>
          <h1 className="font-serif-display text-5xl sm:text-6xl lg:text-[5rem] font-light leading-[1.05] tracking-tight mt-8 text-[#1E1E2A]">
            Ateliers de constellations
            <br />
            <span className="italic text-[#3A2E6E]">familiales</span>
          </h1>
        </Reveal>

        <Reveal delay={0.18}>
          <p className="mt-7 text-xl md:text-2xl font-serif-display text-[#3A2E6E]">
            Dates et inscriptions
          </p>
        </Reveal>

        <Reveal delay={0.26}>
          <p className="mt-6 text-base md:text-lg text-[#5F6170] leading-relaxed max-w-2xl mx-auto">
            Des temps de travail en groupe pour mettre en lumière les dynamiques
            invisibles et comprendre ce qui se rejoue.
          </p>
        </Reveal>

        <Reveal delay={0.34}>
          <a
            href="#calendrier"
            data-testid="cal-hero-cta"
            className="mt-10 group bg-[#2847B8] text-white hover:bg-[#3A2E6E] transition-all duration-300 rounded-full px-8 py-4 font-medium inline-flex items-center justify-center gap-2"
          >
            Voir les prochaines dates
            <ArrowDown className="w-4 h-4 group-hover:translate-y-1 transition-transform" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
